import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "../../Components/ui/form/form";
import { Input, Select } from "../../Components/ui/form";
import { useMutate } from "../../Hooks/use-mutate";
import { Card } from "../../Components/ui/card";

type LocationPostData = {
  loc_name: string;
  loc_street: string;
  loc_city: string;
  state: string;
  loc_zip: string;
  loc_country: string;
};

type LocationResponse = {
  id: number;
  loc_name: string;
};

export const CreateLocation = ({ cancel }: { cancel: () => void }) => {
  const [locName, setLocName] = useState("");
  const [locStreet, setLocStreet] = useState("");
  const [locCity, setLocCity] = useState("");
  const [state, setState] = useState("");
  const [locZip, setLocZip] = useState("");
  const [locCountry, setLocCountry] = useState("");

  const navigate = useNavigate();

  const submitResult = useMutate<LocationPostData, LocationResponse>(
    "/assets/locations/v2/",
    "POST",
  );

  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();
    const data: LocationPostData = {
      loc_name: locName,
      loc_street: locStreet,
      loc_city: locCity,
      state: state,
      loc_zip: locZip,
      loc_country: locCountry,
    };

    try {
      const response = await submitResult.mutate(data);
      if (response?.status === 201) {
        navigate(`/locations/${response.data?.id}`);
      }
    } catch (error) {
      console.error("Error creating location:", error);
    }
  };

  return (
    <div className="page-mask page-mask-animation">
      <Card title="Create Location" titleKey="createLocation" size="sm">
        <Form
          onSubmit={handleSubmit}
          isLoading={submitResult.isLoading}
          cancel={cancel}
        >
          <Input
            label="name"
            value={locName}
            onChange={(e) => setLocName(e.target.value)}
          />
          <Input
            label="address"
            value={locStreet}
            onChange={(e) => setLocStreet(e.target.value)}
          />
          <Input
            label="city"
            value={locCity}
            onChange={(e) => setLocCity(e.target.value)}
          />
          <Input
            label="state"
            value={state}
            onChange={(e) => setState(e.target.value)}
          />
          <Input
            label="zip"
            value={locZip}
            onChange={(e) => setLocZip(e.target.value)}
          />
          <Select
            label="country"
            value={locCountry}
            onChange={(e) => setLocCountry(e.target.value)}
            options={[
              { optionValue: "USA", optionLabel: "usa" },
              { optionValue: "Mexico", optionLabel: "mexico" },
            ]}
          />
        </Form>
      </Card>
    </div>
  );
};
